window.onscroll = function() {
  let scrollButton = document.querySelector('.js-bottom-navbar');
  
  if(window.scrollY >= 280) {
    scrollButton.style.visibility="visible"
    scrollButton.style.opacity="100%"
  } else {
    scrollButton.style.visibility="hidden";
    scrollButton.style.opacity="0";
  }
};
